exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n.list {\n  list-style: none; }\n\n.list__item {\n  display: flex;\n  align-items: center; }\n\n.list__content {\n  padding: 0 10px; }\n\n.list--ordered {\n  counter-reset: order; }\n  .list--ordered > .list__item::before {\n    font-weight: 700;\n    counter-increment: order;\n    content: counter(order) \". \"; }\n\n/* Sizes\n   ========================================================================== */\n.list--size-small {\n  font-size: 13px;\n  line-height: 18px; }\n  .list--size-small .list__icon {\n    width: 12px;\n    height: 12px;\n    margin-top: 4px; }\n\n.list--size-medium {\n  font-size: 14px;\n  line-height: 22px; }\n  .list--size-medium .list__icon {\n    width: 14px;\n    height: 14px;\n    margin-top: 4px; }\n\n.list--size-large {\n  font-size: 16px;\n  line-height: 28px; }\n  .list--size-large .list__icon {\n    width: 16px;\n    height: 16px;\n    margin-top: 6px; }\n  .list--size-large .list__content {\n    padding: 0 15px; }\n\n/* Types\n   ========================================================================== */\n.list--type-success .list__icon {\n  color: #6acb4c; }\n\n.list--type-error .list__icon {\n  color: #f54545; }\n\n.list--type-warning .list__icon {\n  color: #eca03e; }\n\n.list--type-info .list__icon {\n  color: #834ba2; }\n\n/* Orientation\n   ========================================================================== */\n.list--orientation-vertical .list__content,\n.list--orientation-vertical.list--large .list__content {\n  padding-right: 0; }\n\n.list--orientation-horizontal {\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n  .list--orientation-horizontal .list__item:last-child .list__content {\n    padding-right: 0; }\n\n.list--orientation-horizontal:not(.list--show-first-icon) .list__item:first-child .list__icon {\n  display: none; }\n\n.list--orientation-horizontal:not(.list--show-first-icon) .list__item:first-child .list__content {\n  padding-left: 0; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};